export function getMainColors() {
  return {
    primary: "#00B4AA",
    success: "#0acf97",
    warning: "#ffbc00",
    danger: "#fa5c7c",
    info: "#39afd1",
    light: "#eef2f7",
    dark: "#313a46",
    lightBlue: "#3966C5",
    lightSecondary: "#727CF5",
    titleColor: "#6c757d",
    textColor: "#98a6ad",
    lightBackground: "rgb(0 180 170 / 13%)",
    breadcrumbItemColor: "#7a8189",
  };
}

///https://stackoverflow.com/questions/1484506/random-color-generator
export function rainbow(numOfSteps: number, step: number) {
  // This function generates vibrant, "evenly spaced" colours (i.e. no clustering). This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
  // Adam Cole, 2011-Sept-14
  // HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
  var r = 0, g = 0, b = 0;
  var h = step / numOfSteps;
  var i = ~~(h * 6);
  var f = h * 6 - i;
  var q = 1 - f;
  switch(i % 6){
      case 0: r = 1; g = f; b = 0; break;
      case 1: r = q; g = 1; b = 0; break;
      case 2: r = 0; g = 1; b = f; break;
      case 3: r = 0; g = q; b = 1; break;
      case 4: r = f; g = 0; b = 1; break;
      case 5: r = 1; g = 0; b = q; break;
  }
  var c = "#" + ("00" + (~ ~(r * 255)).toString(16)).slice(-2) + ("00" + (~ ~(g * 255)).toString(16)).slice(-2) + ("00" + (~ ~(b * 255)).toString(16)).slice(-2);
  return (c);
}

export function getRandomColours(count: number = 100) {
  let colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(rainbow(count, i));
  }
  return colors;
}


export const eChartColours = ["#00b4aa", "#334b49", "#96b1ad", "#7aa1e8", "#416eb0", "#a33178" ];